<template>
  <div>
    <modal-layout-top :title="title" />
    <div class="content slider-modal">
      <label>Lösenord</label>
      <input class="input" placeholder="Lösenord" type="text" v-model="newPin" />
      <modal-layout-buttons :store-name="'users'" />
    </div>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import ModalLayoutTop from '@/components/modals/ModalLayoutTop'
import ModalLayoutButtons from '@/components/modals/ModalLayoutButtons'

export default {
  name: 'user-modal',
  data () {
    return {
      isUpdate: false,
      newPin: null
    }
  },
  components: {
    ModalLayoutTop,
    ModalLayoutButtons
  },
  computed: {
    ...mapState({
      currentUser: state => state.auth.user
    }),
    title () {
      if (this.currentUser.userId === this.user.userId) {
        return 'Nytt lösenord'
      }
      return `Nytt lösenord för ${this.user.fullName}`
    }
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapActions('users', ['changePin', 'changePinAdmin']),

    closePanel (user) {
      this.$emit('closePanel', {
        user
      })
    },
    save () {
      if (this.currentUser.userId === this.user.userId) {
        this.changePin({ newPin: this.newPin }).then(() => this.$emit('closePanel'))
      } else {
        this.changePinAdmin({ id: this.user.userId, newPin: this.newPin }).then(() => this.$emit('closePanel'))
      }
    }
  },
  created () {
    this.$on('emitSave', () => {
      this.save()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/UserPinModal.vue